























































































































































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import { validCPF } from '@/helpers/validCPF';
import { validEmail } from '@/helpers/validEmail';
import { validPersonName } from '@/helpers/validPersonName';
import { validCellphone } from '@/helpers/validCellphone';
import { validTelephone } from '@/helpers/validTelephone';
import { validCrmNumberUf } from '@/helpers/validCrmNumberUf';
import { ContatoBuscaPorCampoParmDTO, ContatoParmDTO } from '@/interfaces/crm-contact';
import * as service from '@/services/crm-contact';
import * as resize from '@/subjects/resize';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UiSelectInstitution from '../institution/select-institution.vue';
import ContactExistsDialog from './contact-exists-dialog.vue';
import UiComboboxIndividual from '@/components/UI/combobox-individual.vue';

@Component({
  components: {
    UiSelectInstitution,
    ContactExistsDialog,
    UiDatePicker,
    UiComboboxIndividual
  }
})
export default class ContactForm extends BaseComponent {
  @Prop()
  id: number;

  @Prop({ default: false })
  edit: boolean;

  @Prop()
  idInstitution: number;

  modalOpen = false;

  dto: any = {};

  hierarchies = [];
  positions = [];

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  contactExistsDialogFlag = false;
  contactExists = null;
  fieldLabel = null;

  public form: any = {
    valid: false,
    rules: {
      nome: [(v) => !!v || 'Informe o Nome completo', (v) => (!!v && validPersonName(v)) || 'Nome completo inválido'],
      email: [(v) => (!v || validEmail(v)) || 'Digite um e-mail válido.', (v) => (validEmail(v) || this.isCelularValido()) || 'Email obrigatório, se não informar o Celular'],
      telefone: [(v) => (!v || validTelephone(v)) || 'Telefone inválido', (v) => (validTelephone(v) || this.isCelularValido()) || 'Telefone obrigatório, se não informar o Celular'],
      celular: [(v) => (!v || validCellphone(v)) || 'Celular inválido'],
      crm: [(v) => (!v || validCrmNumberUf(v)) || 'CRM inválido'],
      nivelHierarquico: [(v) => !!v || 'Informe o Nível Hierárquico'],
      funcao: [(v) => !!v || 'Informe a Função'],
      instituicoes: [(v) => (!!v && v.length > 0) || 'Selecione a Instituição'],
      cpf: [(v) => (!v || validCPF(v)) || 'Digite um CPF válido.']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (this.id == null) {
      setTimeout(() => {
        this.modalOpen = true;
      }, 50);
    }

    this.loadHierarchies();
    this.loadPositions();
  }

  loadHierarchies() {
    service.listCrmContactsHierarchies().subscribe(
      (res) => {
        this.hierarchies = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  loadPositions() {
    service.listCrmContactsPositions().subscribe(
      (res) => {
        this.positions = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }

    this.loader.start('Carregando ...');
    service.getCrmContactDetails(id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.modalOpen = true;
        this.loader.stop();
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }
    let parm = Object.assign(new ContatoParmDTO(), this.dto);

    let obs: Observable<any> = null;
    if (this.dto.id) {
      parm.id = this.dto.id;
      obs = service.updateCrmContacts(parm);
    } else {
      obs = service.saveCrmContacts(parm);
    }
    this.loader.start('Processando ...');
    obs.subscribe(
      (id) => {
        this.loader.stop();
        this.toast.show('Contato salvo com sucesso', 'success');
        service.getCrmContactDetails(id).subscribe(
          (res) => {
            this.$emit('afterSave', res);
          },
          (error) => {
            this.$emit('afterSave', null);
          }
        );
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }

  findByField(field, fieldLabel, value) {
    if (!value) {
      return;
    }
    let parm = new ContatoBuscaPorCampoParmDTO();
    parm.campo = field;
    parm.valor = value;
    parm.idNotIn = this.dto.id ? this.dto.id : null;

    service.findCrmContactDetailsByField(parm).subscribe(
      (res) => {
        if (res && res.origemResult) {
          this.openContactExistsDialog(res, fieldLabel);
        }
      },
      (error) => {}
    );
  }

  openContactExistsDialog(contact, fieldLabel) {
    this.contactExists = contact;
    this.fieldLabel = fieldLabel;
    this.contactExistsDialogFlag = true;
  }

  closeContactExistsDialog() {
    this.contactExistsDialogFlag = false;
  }

  loadContactExistsDialog(contact) {
    if (contact.id) {
      this.dto = { ...contact };
    } else {
      Object.keys(contact).forEach((prop) => {
        if (!!contact[prop]) {
          this.dto[prop] = contact[prop];
        }
      });
    }
    this.closeContactExistsDialog();
  }

  @Watch('idInstitution', { immediate: true })
  onIdInstitutionChange(v) {
    if (!v) {
      return;
    }
    if (!this.dto.idsInstituicoes) {
      this.dto.idsInstituicoes = [];
    }
    this.dto.idsInstituicoes.push(v);
  }

  isCelularValido() {
    return validCellphone(this.dto.celular);
  }

  @Watch('dto.email')
  @Watch('dto.telefone')
  @Watch('dto.celular')
  triggerGroupValidation() {
    this.$refs['email'].validate();
    this.$refs['telefone'].validate();
    this.$refs['celular'].validate();
  }
}
